import ServiceBus from "servicestack/service-bus";
import basicController from "servicestack/basic.controller.properties";
import parserPrompt from "webmodals/parser/parser-prompt";
import modals from "webmodals/modals";
import $session from "servicestack/session";
import cache from "emun.products/lists/product-list.cache";
import config from "emun.products/product.config";
// import moment from "moment";

export default class ProductListPromptController {
	constructor(options) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.config = config;
		const retailerId = options.retailerId || $session.retailerId;
		const {
			request = {},
			hideRetailer = false,
			hideNonRetailer = false,
			simple,
			title,
		} = options;

		$ctrl.hideRetailer = !!retailerId || !!hideRetailer;
		$ctrl.hideNonRetailer = !!hideNonRetailer;
		$ctrl.simple = !!simple;
		$ctrl.request = {
			id: request.id,
			retailerId,
			label: request.label,
			description: request.description,
			expiresOn: request.expiresOn
				? moment(request.expiresOn)
				: moment().add($ctrl.config.listDaysExpire, "d"),
			tags: request.tags || [],
			visibility: request.visibility || (retailerId ? ["OrderView"] : []),
			listType: retailerId ? 'WISHLIST' : "PRODUCTLIST",
			retailerAuthorization:
				request.retailerAuthorization ||
				(retailerId ? { [retailerId]: true } : {}),
		};
		if ($ctrl.config.defaultProductListVisibility.length) {
			$ctrl.request.visibility = $ctrl.config.defaultProductListVisibility;
		}
		$ctrl.action = request.id ? "Update" : "Create";
		$ctrl.bus = new ServiceBus();
		$ctrl.bus
			.read("QueryProductListVisibility.json")
			.then(({ data: { results } }) => {
				$ctrl.visibility = results;
				$ctrl.repvisibility = results.filter(v => v.name == "Order Entry" || v.name == "Left Nav");
			});
		$ctrl.title = title || `${$ctrl.action} Product List...`;
		$ctrl.realm = "ProductList";
		$ctrl.tagCriteria = {
			$productlistId: $ctrl.request.id,
			//$productlistLabel: $ctrl.request.label
		};
		$ctrl.users = [];
		$ctrl.usersSelected = [];
		$ctrl.bus.read("QueryNonRetailerUsers.json?Active=1&orderBy=userName").then(function(res) {
			res.data.results.forEach(function(u) {
				if (u.userName) {
					$ctrl.users.push(u);
				}
			});
		});
		$ctrl.bus.read("QueryUsers.json?ProductListAccess="+ $ctrl.request.id).then(function(res) {
			res.data.results.forEach(function(u) {
				$ctrl.usersSelected.push(u);
			})
		})

	}

	$onInit() {
		const $ctrl = this;
		$ctrl.buildRetailers();
	}

	parseRetailers() {
		const $ctrl = this;
		return parserPrompt({
			delimiter: /[\s,]+/gi,
			title: "Add customer(s)...",
			label: "#(s)",
			subTitle: "Enter customer numbers separated by comma or white-space",
		}).then((retailerIds) =>
			$ctrl.bus
				.read("BrowseRetailers.json", { IdIn: retailerIds })
				.then(({ data: { results } }) => {
					console.debug("BrowseRetailers.json", { retailerIds, results });
					for (const r of results) {
						if (!$ctrl.request.retailerAuthorization[r.id]) {
							$ctrl.request.retailerAuthorization[r.id] = false;
							$ctrl.retailers.push(r);
						}
					}
					$ctrl.findRetailer = null;
					return $ctrl.buildRetailers();
				})
		);
	}

	addRetailer(retailer) {
		const $ctrl = this;
		if (!$ctrl.request.retailerAuthorization[retailer.id]) {
			$ctrl.request.retailerAuthorization[retailer.id] = false;
			$ctrl.retailers.push(retailer);
		}
		$ctrl.findRetailer = null;
		$ctrl.buildRetailers();
	}

	toggleRetailer(retailerId) {
		const $ctrl = this;
		$ctrl.request.retailerAuthorization[retailerId] = !$ctrl.request
			.retailerAuthorization[retailerId];
	}

	removeRetailer(retailerId) {
		const $ctrl = this;
		delete $ctrl.request.retailerAuthorization[retailerId];
		$ctrl.buildRetailers();
	}

	buildRetailers() {
		const $ctrl = this;
		const idIn =
			Object.keys($ctrl.request.retailerAuthorization).join(",") || "IGNORE";
		let url = `BrowseRetailers.json?OrderBy=Id,CompanyName&IdIn=${idIn}`;

		return $ctrl.bus.read(url).then((res) => {
			$ctrl.retailers = res.data.results.map((r) =>
				Object.assign(
					{
						auth: $ctrl.request.retailerAuthorization[r.id],
					},
					r
				)
			);
		});
	}

	findRetailers(val) {
		const $ctrl = this;
		let url = `BrowseRetailers.json?Take=15&JsConfig=ExcludeDefaultValues&Search=${val}&OrderBy=Id`;
		return $ctrl.bus
			.send(url)
			.then((res) => ($ctrl.retailersFound = res.data.results));
	}

	submit() {
		const $ctrl = this;

		$ctrl.bus
			.send(`${$ctrl.action}ProductList.json`, $ctrl.request)
			.then(function (response) {
				$ctrl.bus.send("CreateProductListAccess.json", {
					ProductListId: response.data.id,
					UserIds: $ctrl.usersSelected.map(u => u.userName)
				});
				$ctrl.$emit("listSaved", $ctrl);
				$ctrl.$emit("refresh-product-lists", response);
				cache.record(response.data.id);
				$ctrl.$close(response.data);
				// $ctrl.$state.go("product-list-viewer", {
				//   productListId: response.data.id
				// });
			});
	}

	delete() {
		const $ctrl = this;
		$ctrl.$close($ctrl.request);
		return modals
			.confirm("Please confirm that you would like to delete this list.", "Delete Product List")
			.result.then(function () {
				$ctrl.bus
					.send("DeleteProductList.json", $ctrl.request)
					.then(function (response) {
						$ctrl.$emit("listDeleted", $ctrl);
						$ctrl.$emit("refresh-product-lists", response);
					});
			});
	}
	
	dismiss() {
		const $ctrl = this;
		//$ctrl.$emit('listSaved', $ctrl);
		$ctrl.$dismiss();
	}
}
